<template>
    <component :is="propWinDataObj.window" ref="propWin" :dataObj='propWinDataObj'></component>
</template>
<script>
    import DefectPropertyWin from '@/components/Web3dModels/DefectPropertyWin'

    export default {
        name: 'PropWinowManager',
        components: {DefectPropertyWin},
        data : function(){
            return {
                propWindow:''
            }
        },
        props:['propWinDataObj'],

    }
</script>
<style lang="less" scoped>
   
</style>



// WEBPACK FOOTER //
// src/plugins/components/PropertyWindows.vue